import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { ID } from '@core/ngrx-legacy';

import type {
  RequisitionsFlowsUpdateBody,
  RequisitionFlowsResponse,
  RequisitionFlowResponse,
} from './flows.types';

@Injectable({ providedIn: 'root' })
export class RequisitionsFlowsHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetchCollection(): Observable<RequisitionFlowsResponse> {
    return this.httpApi.get('/requisitions/settings/approval_flows');
  }

  public create(body: RequisitionsFlowsUpdateBody): Observable<RequisitionFlowResponse> {
    return this.httpApi.post('/requisitions/settings/approval_flows', {}, body);
  }

  public update(id: ID, body: RequisitionsFlowsUpdateBody): Observable<RequisitionFlowResponse> {
    return this.httpApi.patch(`/requisitions/settings/approval_flows/${id}`, {}, body);
  }

  public delete(id: ID): Observable<RequisitionFlowResponse> {
    return this.httpApi.delete(`/requisitions/settings/approval_flows/${id}`);
  }
}
